<template>
  <div>
    <div
      id="carousel"
      class="page-header clear-filter"
    >
      <el-carousel height="100vh">
        <el-carousel-item>
          <!--
              <video autoplay muted loop id="myVideo">
                <source src="img/tpcity.mp4" type="video/mp4">
              </video>
              -->
          <parallax 
            class="page-header-image"
            style="background-image:url('img/transplus_about.jpg')"
          />
              
          <div class="content-center brand">
            <h1>Heading</h1>
            <h2>Test Animated PNG</h2>
            <img 
              src="img/elephant.png"
              alt="Second slide"
            >
          </div>
          <div class="carousel-caption d-none d-md-block">
            <h5>IT Project Manager and Software Engineer</h5>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <!--
              <img class="d-block" src="img/bg3.jpg" alt="Second slide" width="100%" height="100%" />
              -->
          <parallax 
            class="page-header-image"
            style="background-image:url('img/bg3.jpg')"
          />
          <div class="carousel-caption d-none d-md-block">
            <h5>Somewhere Beyond, United States</h5>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <!--<img class="d-block" src="img/bg4.jpg" alt="Third slide" width="100%" height="100%" />-->
          <parallax 
            class="page-header-image"
            style="background-image:url('img/bg4.jpg')"
          />
          <div class="carousel-caption d-none d-md-block">
            <h5>Yellowstone National Park, United States</h5>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    
    <basic-elements />
    <navigation />
    <tabs-section />
    <progress-pagination />
    <notifications />
    <typography />
    <javascript-components />
    <carousel-section />
    <nucleo-icons-section />    
    
    <!--
    <div class="section">
      <div class="container text-center">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Completed with examples</h2>
            <h5 class="description">
              The kit comes with three pre-built pages to help you get started
              faster. You can change the text and images and you're good to go.
              More importantly, looking at them will give you a picture of what
              you can built with this powerful Bootstrap 4 ui kit.
            </h5>
          </div>
        </div>
      </div>
    </div>
    <examples-section></examples-section>    
    -->

    <!--
    <signup-form></signup-form>    
    <download-section></download-section>
    -->
  </div>
</template>
<script>
import { Parallax } from '@/components';
import BasicElements from './components/BasicElementsSection';
import Navigation from './components/Navigation';
import TabsSection from './components/Tabs';
import ProgressPagination from './components/ProgressPagination';
import Notifications from './components/Notifications';
import Typography from './components/Typography';
import JavascriptComponents from './components/JavascriptComponents';
import CarouselSection from './components/CarouselSection';
import NucleoIconsSection from './components/NucleoIconsSection';
import SignupForm from './components/SignupForm';
import ExamplesSection from './components/ExamplesSection';
import DownloadSection from './components/DownloadSection';

// In your VueJS component.
import { VueperSlides, VueperSlide } from 'vueperslides'
// Since v. 1.6.0, you need to include Vueper Slides CSS file for default styles.
import 'vueperslides/dist/vueperslides.css'

import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: 'Index',
  bodyClass: 'index-page',
  components: {
    Parallax,
    BasicElements,
    Navigation,
    TabsSection,
    ProgressPagination,
    Notifications,
    Typography,
    JavascriptComponents,
    CarouselSection,
    NucleoIconsSection,
    SignupForm,
    ExamplesSection,
    DownloadSection,
    VueperSlides, 
    VueperSlide,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem     
  },
  data: () => ({
    pauseOnHover: true,
    autoPlaying: true,
    internalAutoPlaying: true,    
    slides: [
      {
        title: 'Slide #1',
        content: 'Slide content 1.'
      },
      {
        title: 'Slide #2',
        content: 'Slide content 2.'
      },
      {
        title: 'Slide #3',
        content: 'Slide content 3.'
      },            
    ]
  })  
};
</script>
<style>
/*
.el-carousel__arrow--right{
  padding-right: 60px; 
}
.el-icon-arrow-left, 
.el-icon-arrow-right{
  padding: 10px;  
  font-size: 48px;
  font-weight: bolder;
}
.el-icon-arrow-left:hover, 
.el-icon-arrow-right:hover{
  padding: 10px;  
  background-color:rgba(0,0,0,.5);
  border-radius: 50%;
}
*/

</style>
